var render, staticRenderFns
import script from "./disable.vue?vue&type=script&lang=js&"
export * from "./disable.vue?vue&type=script&lang=js&"
import style0 from "./disable.vue?vue&type=style&index=0&id=a03fe36c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03fe36c",
  null
  
)

export default component.exports